import { motion } from "framer-motion";

const PACKAGES = [
    {
        name: "The Atelier",
        tagline: "Elopements & micro-weddings up to 30 guests",
        image:
            "https://static.wixstatic.com/media/2ffe17_9723f2ce2eec44a188280dd07f3aea67~mv2.png/v1/fill/w_1800,h_1300,al_c,q_85,enc_auto/courtyard.png",
        details: [
            "Curated ceremony for up to 30 guests in the mosaic courtyard",
            "Private photography hour in the Van Gogh gallery",
            "Intimate dinner styled by our culinary partners",
            "Atanasio tequila pour for the couple and witnesses",
        ],
    },
    {
        name: "The Hacienda",
        tagline: "Intimate weddings up to 60 guests",
        image:
            "https://static.wixstatic.com/media/d92b8c_2a1a3ba40f2344daa7201458da15291c~mv2.jpg/v1/fill/w_1800,h_1300,al_c,q_85,enc_auto/hacienda_pkg.jpg",
        details: [
            "Exclusive use of the mosaic courtyard & gardens",
            "Ceremony backed by the Van Gogh sunflower mosaic",
            "8-hour event window with sunset ceremony",
            "Dressing suites for both parties",
        ],
    },
    {
        name: "The Masterpiece",
        tagline: "Signature weddings up to 100 guests",
        image:
            "https://static.wixstatic.com/media/d92b8c_1fc352949a994339b1e1463363b00051~mv2.jpg/v1/fill/w_1800,h_1300,al_c,q_85,enc_auto/main_hall.jpg",
        details: [
            "Full estate access from morning through midnight",
            "Main hall with antique mirrors, classic piano and hand-decorated ceilings",
            "Gold Tiffany chairs, round tables, floral décor included",
            "Private Atanasio tequila tasting for the wedding party",
        ],
    },
];

export default function Services() {
    return (
        <section
            id="packages"
            className="section-py container-px bg-[hsl(var(--muted))]"
            data-testid="packages-section"
        >
            <div className="max-w-3xl">
                <p className="overline">Wedding Collections</p>
                <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05]">
                    Three collections.<br />
                    <em className="italic text-[hsl(var(--primary))]">One unforgettable evening.</em>
                </h2>
                <p className="mt-6 text-muted-foreground text-lg font-light max-w-2xl">
                    Each López Hill wedding is built bespoke around the courtyard, the
                    light and the season. Begin with a collection — we will tailor every
                    detail in conversation with you.
                </p>
            </div>

            <div className="mt-20 space-y-20">
                {PACKAGES.map((p, i) => (
                    <motion.article
                        key={p.name}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.9, delay: i * 0.08 }}
                        viewport={{ once: true, margin: "-80px" }}
                        className={`grid lg:grid-cols-12 gap-10 lg:gap-16 items-center ${
                            i % 2 ? "lg:[&>div:first-child]:order-2" : ""
                        }`}
                        data-testid={`package-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
                    >
                        <div className="lg:col-span-7 relative overflow-hidden">
                            <img
                                src={p.image}
                                alt={p.name}
                                className="w-full h-[360px] sm:h-[480px] object-cover transition-transform duration-[1400ms] hover:scale-[1.03]"
                            />
                            <span className="absolute top-6 left-6 font-serif italic text-white text-lg tracking-wide drop-shadow">
                                0{i + 1}
                            </span>
                        </div>

                        <div className="lg:col-span-5">
                            <h3 className="font-serif text-3xl sm:text-4xl tracking-tight">
                                {p.name}
                            </h3>
                            <p className="mt-2 text-[hsl(var(--primary))] text-sm tracking-[0.2em] uppercase">
                                {p.tagline}
                            </p>
                            <ul className="mt-8 space-y-4">
                                {p.details.map((d) => (
                                    <li
                                        key={d}
                                        className="flex gap-4 text-muted-foreground text-base font-light leading-relaxed border-b border-border/60 pb-4 last:border-0"
                                    >
                                        <span className="text-[hsl(var(--accent))] font-serif italic text-xl leading-none">
                                            &mdash;
                                        </span>
                                        {d}
                                    </li>
                                ))}
                            </ul>
                            <a
                                href="#booking"
                                className="inline-block mt-10 px-7 py-3 border border-[hsl(var(--primary))] text-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))] hover:text-[hsl(var(--primary-foreground))] transition-all duration-300 text-xs tracking-[0.25em] uppercase"
                                data-testid={`enquire-${p.name.toLowerCase().replace(/\s+/g, "-")}-btn`}
                            >
                                Enquire about {p.name}
                            </a>
                        </div>
                    </motion.article>
                ))}
            </div>
        </section>
    );
}
